import axios from "axios";

export const uploadMenuPdf = () => {
    return new Promise((resolve, reject) => {
        axios.get(`/api/menu/upload`)
        .then((response) => {
            resolve({status: 'success', response: response});
        })
        .catch((error) => reject({status: 'error', message: error}))
    })
};

export const updateDataFromDrive = () => {
    return new Promise((resolve, reject) => {
        axios.get(`/api/goodrecord/update`)
        .then((response) => {
            resolve({status: 'success', response});
        })
        .catch((error) => reject({status: 'error', message: error}))
    })
}